import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { ButtonMain } from '»components/atoms/Buttons';
import { onboardingDocumentsSelector } from '»components/Auth/Onboarding/redux/onboarding.selectors';
import { questionnaireSlice } from '»components/Questionnaire/redux';
import { currentStepQuestionnaireSelector } from '»components/Questionnaire/redux/questionnaire.selectors';
import { useCurrentPage } from '»utils/customHooks';

import { onboardingSlice } from '../../Auth/Onboarding';
import { ButtonsContainer } from './TrlFormButtons.styles';

export const TrlFormButtons = ({
  fixedAtBottom,
  advanceButtonName,
  isAdvanceButtonDisabled,
  handleForwardButtonClick,
}) => {
  const dispatch = useDispatch();
  const formikContext = useFormikContext();
  const location = useLocation();

  const {
    isOnboardingInitialOtpStep,
    isOnboardingMainFormStep,
    isOnboardingQuestionnaire,
    isSettingsMainPage,
    isSettingsQuestionnaire,
    isOnboardingDocumentsAttach,
  } = useCurrentPage(location.pathname);

  const isSettings = isSettingsMainPage || isSettingsQuestionnaire;
  const documents = useSelector(onboardingDocumentsSelector);

  const currentQuestionnaireStep = useSelector(
    currentStepQuestionnaireSelector,
  );

  return (
    <ButtonsContainer
      className="formButtonsContainer"
      fixedAtBottom={fixedAtBottom}
      isSettingsQuestionnaire={isSettings}
    >
      {(!isSettings || (isSettings && currentQuestionnaireStep !== 1)) && (
        <ButtonMain
          className="backButton"
          onClick={() => {
            if (
              (isOnboardingQuestionnaire ||
                isSettingsQuestionnaire ||
                isSettingsMainPage) &&
              currentQuestionnaireStep !== 1
            ) {
              dispatch(
                questionnaireSlice.actions.setQuestionnaireCurrentStep({
                  direction: 'backward',
                }),
              );
            } else {
              if (isOnboardingDocumentsAttach) {
                const contractIndex = documents.findIndex(
                  (doc) => doc.isFinancialContract === 'S',
                );
                dispatch(
                  onboardingSlice.actions.removeDocument({
                    index: contractIndex,
                  }),
                );
              }
              dispatch(
                onboardingSlice.actions.setOnboardingCurrentStep({
                  direction: 'backward',
                }),
              );
            }
          }}
          variant="secondary"
          expressionId="TRLT_UI-BACK"
          disabled={isOnboardingInitialOtpStep || isOnboardingMainFormStep}
        />
      )}

      <ButtonMain
        className="submitButton"
        expressionId={advanceButtonName}
        type="submit"
        isLoading={formikContext?.isSubmitting}
        disabled={isAdvanceButtonDisabled}
        onClick={handleForwardButtonClick}
      />
    </ButtonsContainer>
  );
};

TrlFormButtons.propTypes = {
  fixedAtBottom: PropTypes.bool,
  advanceButtonName: PropTypes.string.isRequired,
  isAdvanceButtonDisabled: PropTypes.bool,
  handleForwardButtonClick: PropTypes.func,
};
